import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StartPage from '../PAGES/StartPage';
import SkillPage from '../PAGES/SkillPage';
import SizePage from '../PAGES/SizePage';
import GamePage from '../PAGES/GamePage';
import HelpPage from '../PAGES/HelpPage';
import { START_PAGE, GAME_PAGE, HELP_PAGE, SKILL_PAGE, SIZE_PAGE } from '../../HOME/const';
import { GOTO_START_PAGE } from '../../HOME/REDUX/actions';

const Pairanoia = () => {
  const dispatch = useDispatch();
  let page = useSelector(state => state.common.page);

  if (!page) {
    dispatch(GOTO_START_PAGE);
  }

  return (
    <>
      {page === START_PAGE ? <StartPage /> : null}
      {page === SKILL_PAGE ? <SkillPage /> : null}
      {page === SIZE_PAGE ? <SizePage /> : null}
      {page === HELP_PAGE ? <HelpPage /> : null}
      {page === GAME_PAGE ? <GamePage /> : null}
    </>
  );
};

export default Pairanoia;
